export default __webpack_public_path__ + "static/Крысиные бега_20-bf8f477368cb9e61f82a525b7cedbf29.jpg";